<app-loader *ngIf="isDisabled"></app-loader>
<div>
    <div class="row m-0">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"
                [routerLink]="['/request/optionalholiday/add/',0]" [disabled]="isDisabled">
                <i class="bi bi-suitcase" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Holiday Request':'Loading...'}}
            </button>
        </div>
    </div>
</div>

<div class="card border-radius-0 mt-1 p-0">
    <div class="card-header">
        <div class="card-title">
            Optional Holiday History
        </div>
    </div>
    <div class="card-body">
        <form class="g-3" name="filterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
            <div class="row pb-2">
                <div class="col-md-3">
                    <label for="FromDateObj" class="form-font-label"><span class="text-danger">*</span>From
                        Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="FromDateObj"
                            [(ngModel)]="Filter.FromDateObj" ngbDatepicker #FromDateObj="ngbDatepicker" required
                            readonly [disabled]="Filter.IsWithdraw" (ngModelChange)="Clear()"/>
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select from date!
                    </div>
                </div>
                <div class="col-md-3">
                    <label for="ToDateObj" class="form-font-label"><span class="text-danger">*</span>To
                        Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="ToDateObj"
                            [(ngModel)]="Filter.ToDateObj" ngbDatepicker #ToDateObj="ngbDatepicker" required readonly
                            [disabled]="Filter.IsWithdraw" (ngModelChange)="Clear()"/>
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select to date!
                    </div>
                </div>
                <div class="col-md-2">
                    <label for="Status" class="form-font-label">Status</label>
                    <select class="form-select" aria-label="ApprovalStatus" placeholder="Status" title="Status"
                        name="Status" data-live-search="true" [(ngModel)]="Filter.ApprovalStatus"
                        #ApprovalStatus="ngModel" required [disabled]="Filter.IsWithdraw" (change)="Clear()">
                        @for (status of common.Status; track status.Value; let i = $index) {
                        <option [value]="status.Value">
                            <div class="row">
                                <div class="col">{{status.Name}}</div>
                            </div>
                        </option>
                        }
                    </select>
                    <div class="invalid-feedback">
                        Please select Status type!
                    </div>
                </div>
                <div class="col" style="align-content: center;font-weight: 500;font-size: 15px;">
                    <span class="Label" style="margin-left: 3%;">
                        <input type="checkbox" name="admincharg" [(ngModel)]="Filter.IsWithdraw" ngbCheckbox
                            (change)="Clear()" />
                        Withdraw Only
                    </span>
                </div>
                <div class="col-md-auto mt-4">
                    <button type="submit" class="btn btn-primary" [disabled]="isDisabled">
                        <i class="bi bi-search" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Search':'Loading...'}}
                    </button>
                </div>
            </div>
        </form>
        <div class="overflow-auto">
            <table datatable [dtOptions]="this.dtoptions" width="100%" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 10px;">#</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">View</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">Withdraw</th>

                        <th style="width: 180px;">Holiday Name</th>
                        <th style="width: 50px;">Type</th>
                        <th style="width: 100px;">Holiday Date</th>
                        <th style="width: 150px;">Request Date</th>
                        <th style="width: 150px;" [ngClass]="{'colHide': !this.Filter.IsWithdraw}">Withdraw Date</th>
                        <th style="width: 100px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">Approvel Status</th>
                        <th style="width: 50px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">Is Consume</th>

                    </tr>
                </thead>
                <tbody>

                    <tr *ngFor="let element of OPHolidays; let i = index">
                        <td style="width: 10px;"> {{i + 1}}</td>
                        <td style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">
                            <div style="width: 70px;"><button type="button" class="btn btn-outline-primary btn-sm"
                                    [routerLink]="['/request/optionalholiday/detail/', this.Filter.IsWithdraw?element['ESS_EmployeeOptionalHolidayID']:element['ESS_EmployeeOptionalHolidayId']]"><i
                                        class="bi bi-info-square me-1"></i>View</button></div>
                        </td>
                        <td style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">
                            <div style="width: 110px;"
                                *ngIf="common.ToLowerCase(element['ApprovalStatus']) == 'pending'"><button
                                    type="button" class="btn btn-outline-primary btn-sm"
                                    (click)="ESS_EmployeeOptionalHolidaySave(i)"><i
                                        class="bi bi-x-circle me-1"></i>Withdraw</button></div>
                        </td>
                        <td style="width: 180px;"> {{element['HolidayName']}}</td>
                        <td style="width: 50px;"> {{element['HolidayType']}}</td>
                        <td style="width: 100px;">{{this.Filter.IsWithdraw?element['HolidayDate']:element['Date']}}</td>
                        <td style="width: 150px;">{{element['RequestDate']}}</td>
                        <td style="width: 150px;" [ngClass]="{'colHide': !this.Filter.IsWithdraw}">
                            {{element['WithdrawDate']}}</td>
                        <td style="width: 100px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}"><span class="badge"
                                [ngClass]="{'success': common.ToLowerCase(element['ApprovalStatus']) == 'approved','warning': common.ToLowerCase(element['ApprovalStatus']) == 'pending','danger': common.ToLowerCase(element['ApprovalStatus']) == 'rejected'}">{{element['ApprovalStatus']}}</span>
                        </td>
                        <td style="width: 50px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">
                            {{element['IsHolidayConsume']?'Yes':'No'}}</td>


                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>